import { ThemeColors } from '../theme-colors';
import { ColorPalette } from '../../base/colorPalette';

export const CustomTooltip = {
	tooltipText: 'var(--epods--color-text-inverted)',
	tooltipPaddingLeftRight: 'var(--epods--tooltip-padding-left-right)',
	tooltipPaddingTopBottom: 'var(--epods--tooltip-padding-top-bottom)',
	tooltipFontSize: 'var(--epods--tooltip-fontSize)',
	tooltipLineHeight: 'var(--epods--tooltip-lineHeight)',
};
